<template>
  <div v-loading="loading">
    <wt-re-request-tip :re-load="load" v-show="loadFailed"></wt-re-request-tip>
    <pt-trust-deed-detail :order="detail"  class="pt-trust-deed-detail__withData" @on-reload="load" :needRefreshOrder="needRefreshOrder" @polling-reload="pollingReload" @cancelBills="cancelBills"></pt-trust-deed-detail>
  </div>
  
</template>

<script>
import PtTrustDeedDetail from './index'
export default {
  name: 'pt-trust-deed-detail__withData',
  components: {
    'pt-trust-deed-detail': PtTrustDeedDetail
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      detail: null,
      // 页面是否在进行数据loading
      loading: false,
      // 是否加载失败，用于显示遮罩层，用户可触发重试
      loadFailed: false,
      pollingTimer:null,
			billExecuteI:0,
			billExecuteTaskI:0,
			executeTimer:null,
      needRefreshOrder: false,
      refreshNum:0
    }
  },
  watch: {
    id (val) {
      this.load()
    }
  },
  methods: {
		//撤销结算或开票
		cancelBills(type,text){
			let data={
				ids:[this.id],
				operType:type
			}
			this.$store.dispatch('cancelBills',data).then(data=>{
				this.$message.success(`撤销${text}成功！`)
				this.load()
			}).catch(err=>{
				this.$message.error(err || `撤销${text}失败！`)
			})
		},
    // 加载详情数据
    load (statusResult) {
      this.loading = true
      this.$store.dispatch('getBill', this.id).then((data) => {
        this.loadFailed = false
        this.loading = false
        this.detail = data
				if((data.nextBillAction==='BILL_EXECUTE'||data.nextBillAction==='BILL_ASSIGN')&&statusResult==='REDO_REPORT_GENERATE'){//执行中或者待分派，如果是处理待办（重出报告需刷新10s，。2s一次）
					this.billExecuteI=0
					clearTimeout(this.executeTimer)
          this.executeTimer = null
          this.refreshNum = 0
					this.pollingReload(false,statusResult)
				}
      }).catch((error) => {
        this.loading = false
        this.loadFailed = true
        console.error(error)
        this.$message.error(error || '获取委托单信息失败！')
      })
    },
    pollingReload(isEdit,statusResult){
      this.$store.dispatch('getBill', this.id).then((data) => {
        this.detail = data
				let futureTasks=this.detail.futureTasks&&this.detail.futureTasks[0]&&this.detail.futureTasks[0].billActionData
				let isRedoReport=futureTasks&&futureTasks.futureActionAcceptableResults&&futureTasks.futureActionAcceptableResults[0]&&futureTasks.futureActionAcceptableResults[0]==='REDO_REPORT_GENERATE'//是否有重出待办报告
        if ((data.nextBillAction === 'BILL_EXECUTE' || data.nextBillAction === 'BILL_ASSIGN') && (isEdit || statusResult === 'REDO_REPORT_GENERATE')) {//编辑之后，如果委托单是执行中或待分派的状态，刷新接口10次（2s一次）；如果是处理待办（重出报告需刷新10s，。2s一次。如果在10s之内有重出报告待办被刷新出来则停止刷新）
          this.billExecuteI++
					if(statusResult==='REDO_REPORT_GENERATE'){
						if(this.billExecuteI>5&&this.executeTimer||isRedoReport){
								return
						}
          }
					if(this.billExecuteI>10&&this.executeTimer){
						clearTimeout(this.executeTimer)
						this.executeTimer=null
						return
          }
          if (this.billExecuteI <= 10 || (statusResult === 'REDO_REPORT_GENERATE' && this.billExecuteI <= 5)) {
            clearTimeout(this.executeTimer)
            this.executeTimer = setTimeout(() => {
							this.pollingReload(isEdit,statusResult) }, 2000)
					}
        }
        let needTimerAction=['BILL_CHECKED','BILL_BACK','BILL_RECEIVE']
        if (needTimerAction.includes(data.nextBillAction)&&!isEdit) {
        this.pollingTimer = setTimeout(() => {
          clearTimeout(this.pollingTimer)
          this.pollingReload()
        }, 1000)
        }
        if (data.nextBillAction === 'BILL_RECEIVE') {
          if (this.refreshNum < 1) {
            this.needRefreshOrder = true
            setTimeout(() => {
              this.needRefreshOrder = false
            }, 200)
          }
          this.refreshNum = this.refreshNum + 1
        }
        if(data.futureTasks&&data.futureTasks.length|| !needTimerAction.includes(data.nextBillAction)){
          this.clearTimer()
          return
        }
      }).catch((error) => {
        console.error(error)
        this.$message.error(error || '获取委托单信息失败！')
      })
    },
    clearTimer () {
      if (this.pollingTimer) clearTimeout(this.pollingTimer)
    }
  },
  created () {
		let lastRouter=this.$router.lastRouter
    if (lastRouter.name === 'trust-deed-form' && lastRouter.params.isEdit) {
			this.pollingReload(true)
		}else{
      this.load()
		}
  },
  destroyed () {
    clearTimeout(this.pollingTimer)
    clearTimeout(this.executeTimer)
    this.pollingTimer=null
    this.executeTimer = null
  }
}
</script>
<style lang="less">
@media screen and (max-width: 1200px) {
  .lab-order-detail {
    width: 15rem;
  }
}
</style>

